// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-avatar[data-v-495de882] {\n  cursor: pointer;\n}\n.c-card[data-v-495de882] {\n  margin: auto;\n  height: 100%;\n  min-width: 275px;\n  max-width: min(400px, 100%);\n  border-radius: 16px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
